import React from 'react';
import Page from '../page';
import Loader from '../loader/loader';
import { useGetAcquisitionsQuery } from '../../store/slices/apiSlice/acquisitions-api-slice';
import AcquisitionsTabs from './acquisitionsTabs';
import './acquisitions.css';

function AcquisitionsPage() {
    const {
        data,
        error,
        isLoading,
    } = useGetAcquisitionsQuery();

    const renderError = () => {
        console.error('Error retrieving acquisitions data', error);
        return <p>Error retrieving acquisitions information</p>;
    };

    return (
        <Page>
            <div className={isLoading ? 'opacity-50' : 'opacity-100'}>
                {isLoading ? (
                    <Loader />
                ) : error ? (
                    renderError()
                ) : (
                    <div className="container-fluid pb-3 ps-0 ps-md-4 pe-2">
                        <div className="row">
                            <div className="col-12">
                                <h1 className="fs-1 lh-1 text-capitalize mb-1">Acquisitions Dashboard</h1>
                            </div>
                            <div className="col-12">
                                <AcquisitionsTabs acquisitionsData={data} />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </Page>
    );
}

export default AcquisitionsPage;
